<section>
<section class="content">
        <div class="box">
          <div class="box-body">
              <div class="row row pl30" style="margin-bottom: 20px !important;">
                <h3>User Designation Rights</h3>
              </div>
              <div class="row">
                  <div class="col-sm-12 box-row" >
                    <div class="page">
                      <div class="toolbar">
                        <div class="col-sm-12 box-row">
                        <div class="col-sm-6 ">
                        <label class="control-label mr-1">
                          Select Designation:</label>
                          <select [(ngModel)]="selectedDesignationId" class="form-control mdInput" (change)="loadRights()">
                            <option *ngFor="let d of designations" [ngValue]="d.value">
                              {{ d.text }}
                            </option>
                          </select>
                        </div>
                    <div class="col-sm-6 right">
                        <a class="btn btn-primary mr-1" href="javascript:void(0)" (click)="selectAll()" *ngIf="!saving && selectedDesignationId && tree.length">
                      Select All
                        </a>

                    <a class="btn btn-primary mr-1" href="javascript:void(0)" (click)="deselectAll()" *ngIf="!saving && selectedDesignationId && tree.length">
                      Deselect All
                    </a>
                      <a href="javascript:void(0)" (click)="save()" class="btn btn-primary" *ngIf="!saving && selectedDesignationId && tree.length"
                              title="Save"> <i class="fa fa-save"></i> &nbsp; <span>{{ saving ? 'Saving...' : 'Save' }}</span> </a>
                        
                      </div>
                      </div>
                    </div>
                      <div *ngIf="loading" class="loading">Loading...</div>

                      <div *ngIf="!loading && selectedDesignationId">
                        <table class="rights-table" *ngIf="filteredTree.length">
                          <thead>
                            <tr>
                              <th style="width: 55%">Menu</th>
                              <th style="width: 9%">Visible</th>
                              <th style="width: 9%">Create</th>
                              <th style="width: 9%">Edit</th>
                              <th style="width: 9%">AddNotes</th>
                              <th style="width: 9%">Delete</th>
                            </tr>
                          </thead>

                          <tbody>
                            <ng-container *ngTemplateOutlet="renderNodes; context:{ $implicit: filteredTree, level: 0 }"></ng-container>
                          </tbody>
                        </table>

                        <div class="empty" *ngIf="!filteredTree.length">No menus found.</div>
                      </div>

                      <ng-template #renderNodes let-nodes let-level="level">
                        <ng-container *ngFor="let n of nodes">
                          <tr>
                            <td>
                              <span [style.paddingLeft.px]="level * 18" class="menu-text">
                                {{ n.menuDesc }}
                              </span>

                              <button class="link-btn" type="button" (click)="applyToChildren(n)" *ngIf="n.children?.length">
                                Apply to children
                              </button>
                            </td>

                            <td class="center">
                              <input type="checkbox" [(ngModel)]="n.canVisible" (change)="onToggle(n,'visible')" />
                            </td>

                            <td class="center">
                              <input type="checkbox" [(ngModel)]="n.canCreate" (change)="onToggle(n,'create')" />
                            </td>

                            <td class="center">
                              <input type="checkbox" [(ngModel)]="n.canEdit" (change)="onToggle(n,'edit')" />
                            </td>

                            <td class="center">
                              <input type="checkbox" [(ngModel)]="n.canAddNotes" (change)="onToggle(n,'addnotes')" />
                            </td>

                            <td class="center">
                              <input type="checkbox" [(ngModel)]="n.canDelete" (change)="onToggle(n,'delete')" />
                            </td>
                          </tr>

                          <ng-container *ngIf="n.children?.length">
                            <ng-container
                              *ngTemplateOutlet="renderNodes; context:{ $implicit: n.children, level: level + 1 }"
                            ></ng-container>
                          </ng-container>
                        </ng-container>
                      </ng-template>
                      <div class="toolbar mt-4">
                        <div class="col-sm-12 box-row">
                        <div class="col-sm-6 ">
                        
                        </div>
                    <div class="col-sm-6 right">
                        <a class="btn btn-primary mr-1" href="javascript:void(0)" (click)="selectAll()" *ngIf="!saving && selectedDesignationId && tree.length">
                      Select All
                        </a>

                    <a class="btn btn-primary mr-1" href="javascript:void(0)" (click)="deselectAll()" *ngIf="!saving && selectedDesignationId && tree.length">
                      Deselect All
                    </a>
                      <a href="javascript:void(0)" (click)="save()" class="btn btn-primary" *ngIf="!saving && selectedDesignationId && tree.length"
                              title="Save"> <i class="fa fa-save"></i> &nbsp; <span>{{ saving ? 'Saving...' : 'Save' }}</span> </a>
                        
                      </div>
                      </div>
                    </div>
                    </div>
                  </div>
              </div>
          </div>
        </div>
</section>
</section>